import { UUID } from 'angular2-uuid';
import { HTTP_METHODS } from './index';
import { FileChangeQItem } from './file-item';
import { ReportLayout } from '../../../vas/business-objects/report-layout/report-layout.model';
import { ReportLayoutChangeQItem } from './report-layout-item';

export interface ChangeQItemArgs {
    account: string;
    created?: Date;
    data: object;
    entity: string;
    id: string;
    key?: string;
    method: string;
    newId?: string;
    origId?: string;
    parentEntity?: string;
    parentId?: string;
    position?: number;
    user: string;
    version?: number;
}

export class ChangeQItem {
    account: string;
    created: Date;
    data: object;
    entity: string;
    id: string;
    key: string;
    method: string;
    parentEntity: string;
    parentId: string;
    position: number;
    user: string;
    version: number;

    constructor(args: ChangeQItemArgs) {

        if (!(args.method in HTTP_METHODS) && args.method !== 'REFRESH') {
            throw new Error(`invalid method "${args.method}"`);
        }

        this.account = args.account;
        this.created = args.created || new Date();
        this.data = args.data || {} as any;
        this.entity = args.entity;
        this.id = args.id;
        this.key = args.key || UUID.UUID();
        this.method = args.method;
        this.parentEntity = args.parentEntity;
        this.parentId = args.parentId;
        this.position = args.position;
        this.user = args.user;
        this.version = args.version || 1;
    }

    update(args = {} as any): ChangeQItem {
        return new ChangeQItem({
            ...this.toObject(),
            ...args
        });
    }

    toObject(): object {
        return {
            account: this.account,
            created: this.created,
            data: this.data,
            entity: this.entity,
            id: this.id,
            key: this.key,
            method: this.method,
            parentEntity: this.parentEntity,
            parentId: this.parentId,
            position: this.position,
            user: this.user,
            version: this.version
        };
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/item.ts